class CartToggler {
    constructor(cart_toggle, side_cart) {
        this.cart_toggle = cart_toggle;
        this.side_cart = side_cart;

        this._bindMethods();

        if (this.cart_toggle !== null) {
            if (this.side_cart !== null) {
                this.cart_toggle.addEventListener("click", this._openSideCart);
            }
            this.cart_count = this.cart_toggle.querySelector(
                '[data-element="count"]',
            );
            this.cart_total = this.cart_toggle.querySelector(
                '[data-element="price"]',
            );
        }
        if (this.side_cart !== null) {
            this.side_cart_is_open = false;
            this.side_cart_close = this.side_cart.querySelector(".js-cart-close");
            if (this.side_cart_close !== null) {
                this.side_cart_close.addEventListener("click", this._closeSideCart);
            }
        }

        document.addEventListener("click", this._maybeCloseCart);
    }

    _bindMethods() {
        this._openSideCart = this._openSideCart.bind(this);
        this._closeSideCart = this._closeSideCart.bind(this);
        this._maybeCloseCart = this._maybeCloseCart.bind(this);
    }

    _openSideCart(event) {
        event.preventDefault();
        if (this.side_cart.classList.contains("toggled")) {
            this.side_cart_is_open = false;
            this.side_cart.classList.remove("toggled");
        } else {
            this.side_cart_is_open = true;
            this.side_cart.classList.add("toggled");
        }
    }

    _closeSideCart(event) {
        event.preventDefault();
        this.side_cart.classList.remove("toggled");
        this.side_cart_is_open = false;
    }

    _maybeCloseCart(event) {
        if (this.side_cart !== null) {
            if (this.side_cart_is_open) {
                let cart = event.target.closest(".js-side-cart");
                let cart_toggle = event.target.closest(".js-cart-toggle");
                if (cart === null && cart_toggle === null) {
                    this.side_cart.classList.remove("toggled");
                    this.side_cart_is_open = false;
                }
            }
        }
    }

    maybe_update_toggle(new_count, new_total) {
        if (this.cart_count !== null) {
            if (new_count > 0) {
                this.cart_count.style.display = "flex";
            } else {
                this.cart_count.style.display = "none";
            }
            this.cart_count.innerHTML = new_count;
        }
        if (this.cart_total !== null) {
            this.cart_total.innerHTML = new_total;
        }
    }
}

export default CartToggler;
